import { getCategoryPageConfig } from '@/lib/aggregation';
import type { Game } from '@/types/games';

export type BiggestWinData = {
    tileData: Game | null;
    stake_amount?: number;
    win_amount?: number;
    multiplier?: number;
    rgLink?: string;
    rgLogo?: string;
    confettiAnimationUrl?: string;
};

export const getBiggestWinData = async (): Promise<BiggestWinData | null> => {
    const categoryPageConfig = await getCategoryPageConfig('biggest-win');

    if (!categoryPageConfig) {
        return null;
    }

    const rgLink = categoryPageConfig?.pageConfig?.product?.data?.header?.data?.responsible_gaming_link?.url;
    const rgLogo = categoryPageConfig?.pageConfig?.product?.data?.header?.data?.responsible_gaming_logo?.url;

    const biggestWinData = categoryPageConfig?.pageConfig?.biggest_win_data;
    const stake_amount = biggestWinData?.stake_amount;
    const win_amount = biggestWinData?.win_amount;
    const multiplier = biggestWinData?.multiplier;
    const confettiAnimationUrl = biggestWinData?.animation_url;

    const tileData =
        (categoryPageConfig?.pageConfig?.content?.data?.zones?.[0]?.data?.body?.[0]?.items?.[0] as Game) || null;

    return {
        tileData,
        stake_amount,
        win_amount,
        multiplier,
        rgLink: rgLink ?? undefined,
        rgLogo: rgLogo ?? undefined,
        confettiAnimationUrl: confettiAnimationUrl ?? undefined
    };
};
